import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import DebtReliefOasisWrapper from "@components/layouts/debtReliefOasisWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
export default function ContactUsHome(): ReactElement {
    return (
        <DebtReliefOasisWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={"#E8EFED"} />
            </div>
            <FormSection iconsFillColor={"#1B6658"} />
        </DebtReliefOasisWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
